import { InputNumber, InputNumberProps } from "antd";
import React from "react";

const InputCurrency = ({ ...props }: InputNumberProps) => {
  const handleFormat = (value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const handleParse = (value) => value.replace(/\$\s?|(,*)/g, "");

  return <InputNumber formatter={(value) => handleFormat(value)} parser={(value) => handleParse(value)} {...props} disabled={props.disabled} />;
};

export default InputCurrency;
